export default __webpack_public_path__ + "static/media/song88_logo.507dcc4d.png";